import { Button } from "@mui/material";
import { ReactComponent as Cross } from "assets/img/card/cross.svg";
import TagManager from 'react-gtm-module';

export default function Medico() {
  const tag = () => {
    TagManager.dataLayer({
      dataLayer: {
        event: 'USA_Landing',
        eventCategory: 'USA_Landing',
        eventAction: 'select_seguro',
        eventLabel: 'medicoSeguro'
      },
    });
  };
  return (
    <div className="insuranceCard">
      <div className="insuranceObjects">
        <div className="">
          <div className="flex justify-center items-center">
            <Cross></Cross>
          </div>
          <div className="flex flex-col justify-center items-center pt-4">
            <div className="paraphsCards">Médico</div>
            <div className="paraphsCards">Seguro</div>
          </div>
        </div>
        <div className="referenceInsurance py-8">
          El mejor seguro médico para ti y tu familia
        </div>
        <Button
          style={{
            backgroundColor: "#039ecc",
            width: "212px",
            height: "48px",
            borderRadius: "8px",
            fontWeight: 600,
            fontSize: "16px",
            textAlign: "center",
            color: "#ffffff",
          }}
          onClick={tag}
          href="https://medicoseguro.inter.mx/"
          target="_blank"
        >
          LO QUIERO
        </Button>
        <p className="lastParaph">Contrata en minutos, no semanas</p>
      </div>
    </div>
  );
}
